import { ProposalType } from '@types';

export const proposalSelectItems = [
  { label: 'Non Geo Gated', value: ProposalType.CryptoVoting },
  { label: 'Geo Gated', value: ProposalType.LandBasedVoting },
  // { label: 'Organisational voting', value: ProposalType.OrganizationalVoting },
];
